/* The piece's page — the gallery, the rail and its arrows. Lifted out of
   sections/main-product.liquid on 2026-11-02; see the note in product-page.css.

   It is loaded with defer, so it runs after the page is parsed and before the window's
   load event. The inline onclick/onscroll handlers in the section — pick(), railScroll(),
   railArrows() — only fire when a visitor acts, by which time these exist. */
  const shots = Array.from(document.querySelectorAll('.plates .shot'));
  const plates = Array.from(document.querySelectorAll('.rail button'));
  const navPrev = document.querySelector('.plate-nav.prev');
  const navNext = document.querySelector('.plate-nav.next');
  const zoom = document.getElementById('zoom');
  const zoomImg = document.getElementById('zoom-img');
  const zoomFilm = document.getElementById('zoom-film');
  let at = 0;

  // One shot is visible and the rest are hidden. A film is paused the moment it leaves the
  // plate, so nothing goes on playing out of sight (owner, 2026-10-20).
  function pick(i) {
    if (i < 0 || i >= shots.length) return;
    shots.forEach(function (s, k) {
      s.hidden = k !== i;
      const film = s.querySelector('video');
      if (!film) return;
      if (k === i) { const p = film.play(); if (p && p.catch) p.catch(function () {}); }
      else { film.pause(); }
    });
    plates.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    at = i;
    if (!zoom.hidden) fillZoom();
    sideArrows();
  }

  function step(by) {
    const to = at + by;
    if (to < 0 || to >= shots.length) return;
    pick(to);
    if (plates[to]) plates[to].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }

  function sideArrows() {
    if (!navPrev) return;
    navPrev.hidden = at <= 0;
    navNext.hidden = at >= shots.length - 1;
  }

  // Whatever is on the plate - a photograph or a film - is what the enlarged view shows.
  // A film is copied into it and played there with controls; the one on the plate is paused
  // meanwhile so the same film is not running twice.
  function fillZoom() {
    const shot = shots[at];
    if (!shot) { closeZoom(); return; }
    zoomFilm.textContent = '';
    const film = shot.querySelector('video');
    if (film) {
      film.pause();
      const copy = film.cloneNode(true);
      copy.removeAttribute('hidden');
      copy.controls = true;
      copy.muted = true;
      copy.loop = true;
      copy.preload = 'auto';
      copy.setAttribute('playsinline', '');
      zoomFilm.appendChild(copy);
      zoomFilm.hidden = false;
      zoomImg.hidden = true;
      zoomImg.removeAttribute('src');   // or the empty src resolves to this page and is fetched
      const played = copy.play();
      if (played && played.catch) played.catch(function () {});
      return;
    }
    const img = shot.querySelector('img');
    if (!img) { closeZoom(); return; }
    zoomImg.src = img.dataset.full || img.src;
    zoomImg.hidden = false;
    zoomFilm.hidden = true;
  }

  function openZoom() {
    if (!shots[at]) return;
    zoom.hidden = false;
    document.body.style.overflow = 'hidden';
    fillZoom();
  }
  function closeZoom() {
    zoom.hidden = true;
    zoomFilm.textContent = '';   // stops the copy playing
    zoomFilm.hidden = true;
    document.body.style.overflow = '';
    const film = shots[at] && shots[at].querySelector('video');
    if (film) { const p = film.play(); if (p && p.catch) p.catch(function () {}); }
  }

  // a film on the plate has no controls of its own, so a click on it enlarges, as on a photograph
  shots.forEach(function (s) {
    const film = s.querySelector('video');
    if (film) film.addEventListener('click', function () { openZoom(); });
  });
  // the dark around the picture closes it, and so does the picture itself
  zoom.addEventListener('click', function (e) {
    if (e.target === zoom || e.target === zoomImg) closeZoom();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !zoom.hidden) closeZoom();
    if (e.key === 'ArrowRight') step(1);
    if (e.key === 'ArrowLeft') step(-1);
  });

  // the thumbnail strip keeps its own arrows, shown only when it has somewhere to scroll
  const rail = document.querySelector('.rail');
  const arrowPrev = document.querySelector('.rail-arrow.prev');
  const arrowNext = document.querySelector('.rail-arrow.next');
  function railScroll(dir) {
    rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
  }
  function railArrows() {
    if (!rail || !arrowPrev) return;
    const room = rail.scrollWidth - rail.clientWidth;
    arrowPrev.hidden = rail.scrollLeft < 8;
    arrowNext.hidden = rail.scrollLeft > room - 8;
  }
  window.addEventListener('load', function () { railArrows(); sideArrows(); });
  window.addEventListener('resize', railArrows);